import React from 'react'
import { b2bMarketFlag, b2bMarketLabel } from '../../utils/b2bMarketDisplay'

type MarketBarsProps = {
    items: Array<{ code: string; widthPct: number; value: string }>
    barColor?: string
}

export const MarketBars: React.FC<MarketBarsProps> = ({ items, barColor = '#16161A' }) => (
    <div className="flex flex-col gap-[7px] mt-1.5 pt-3 border-t border-neutralBlack-200">
        {items.map((item) => {
            const flag = b2bMarketFlag(item.code)
            return (
                <div key={item.code} className="flex items-center gap-2.5">
                    {flag ? (
                        <img
                            src={flag}
                            alt={item.code}
                            className="w-[15px] h-[11px] flex-none rounded-sm object-cover shadow-[0_0_0_1px_rgba(0,0,0,0.08)]"
                        />
                    ) : (
                        <span className="w-[15px] h-[11px] flex-none rounded-sm bg-neutralBlack-100" />
                    )}
                    <span className="w-11 flex-none text-[11.5px] text-neutralBlack-600">{b2bMarketLabel(item.code)}</span>
                    <span className="flex-1 min-w-0 h-1 rounded-full bg-neutralBlack-100 overflow-hidden">
                        <span
                            className="block h-1 rounded-full"
                            style={{ width: `${item.widthPct}%`, background: barColor }}
                        />
                    </span>
                    <span className="min-w-[44px] text-right text-xs text-neutralBlack-800">{item.value}</span>
                </div>
            )
        })}
    </div>
)
